import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactHero = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary/10 via-secondary/5 to-background py-12 md:py-16 lg:py-20 overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-10 w-32 h-32 md:w-48 md:h-48 bg-primary rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 md:w-56 md:h-56 bg-secondary rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 bg-primary/10 rounded-2xl mb-4 md:mb-6">
            <Icon name="MessageCircle" size={32} color="var(--color-primary)" className="md:w-10 md:h-10 lg:w-12 lg:h-12" />
          </div>
          
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4 md:mb-6">
            Get In Touch With Us
          </h1>
          
          <p className="text-base md:text-lg lg:text-xl text-muted-foreground mb-6 md:mb-8">
            We're here to serve you! Reach out for orders, inquiries, or just to say hello. Your satisfaction is our priority.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center items-center">
            <div className="flex items-center gap-2 text-sm md:text-base text-foreground">
              <Icon name="Clock" size={20} color="var(--color-primary)" />
              <span className="font-medium">Daily: 8:00 AM - 10:00 PM</span>
            </div>
            <div className="hidden sm:block w-1 h-1 bg-muted-foreground rounded-full"></div>
            <div className="flex items-center gap-2 text-sm md:text-base text-foreground">
              <Icon name="MapPin" size={20} color="var(--color-primary)" />
              <span className="font-medium">Juba, South Sudan</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;